import React, { useState } from 'react';
import './ConservacionSustentabilidad.scss';
import botonConozcaMas from './Assets/boton_conozcamasaqui.png';

const ConservacionSustentabilidad = () => {
    /**
     * Vista conservación y sustentabilidad
     * 
     */

    const [showConsumoSection, setShowConsumoSection] = useState(false);

    return (
        <div className="ConservacionSustentabilidadMasterContainer">
            <div className="textContentContainer">
                <span className="textContentTitle">Conservación y sustentabilidad</span>
                <span className="textContentContent">El estado tiene una preocupación especial por el desarrollo de las comunidades costeras, en consideración a la conservación de los espacios naturales y el desarrollo de las actividades que allí se generan, de manera de potenciar el uso racional y la capacidad de adaptación frente al cambio climático. Es por ello que dejamos a su disposición información referente a Normativas pesqueras y acuicolas, ley de caletas, Áreas de manejo y Consumo responsable.</span>
            </div>

            <a target="_blank" rel="noopener noreferrer" href="http://www.sernapesca.cl/normativa?areas_de_trabajo[]=3&areas_de_trabajo[]=1288&areas_de_trabajo[]=1289&areas_de_trabajo[]=1290&areas_de_trabajo[]=1291&areas_de_trabajo[]=1292&areas_de_trabajo[]=1293&areas_de_trabajo[]=1294&areas_de_trabajo[]=1295&areas_de_trabajo[]=1296" className="bannerSection Section0">
                <span>Normativas pesqueras y acuícolas</span>
            </a>

            <a target="_blank" rel="noopener noreferrer" href="http://www.sernapesca.cl/normativa-relacionada/ley-ndeg-21027-2017-regula-el-desarrollo-integral-y-armonico-de-caletas" className="bannerSection Section1">
                <span>Ley de caletas</span>
            </a>

            <a target="_blank" rel="noopener noreferrer" href="http://www.subpesca.cl/portal/615/w3-propertyname-543.html" className="bannerSection Section2">
                <span>Áreas de manejo</span>
            </a>

            <div onClick={() => {setShowConsumoSection(showConsumoSection => !showConsumoSection); }} className="bannerSection Section3">
                <span className="absoluteCenter">Consumo responsable</span>
                <span className="absoluteBottom">Medidas preventivas para el consumidor.</span>
            </div>
            <div className={"ConsumoSection " + (showConsumoSection === true ? "consumoSectionVisible" : "consumoSectionHidden")}>
                <img onClick={() => { window.open('https://www.achipia.gob.cl/wp-content/uploads/2016/03/Consejos-para-consumo-seguro-de-pescados-y-mariscos.pdf', '_blank'); }} src={botonConozcaMas} alt=""/>
            </div>
        </div>
    )
}

export default ConservacionSustentabilidad;